export default "__VITE_ASSET__1f9f38bb__"